<template>
  <div class="package loader-container">
    <h1>{{ packageInfo.description }}</h1>
    <div v-for="gap in packageInfo.gaps" :key="gap.id">
      <div v-for="folder in gap.folders" :key="folder.id">
        <button type="button" @click="fillGap(folder.id)">{{ folder.name }}</button>
      </div>
    </div>
    <Loader :loading="loadingPackage" />
  </div>
</template>
<script>
import Service from '@/services/Service.js';
import Loader from '@/components/Loader.vue';

export default {
  components: { Loader },
  props: {
    packageId: { type: String, default: null }
  },
  data: function() {
    return {
      packageInfo: {},
      loadingPackage: false
    };
  },
  created() {
    this.loadingPackage = true;

    Service.getPackage(this.packageId).then(response => {
      this.packageInfo = response.data;
      this.loadingPackage = false;
    });
  },
  methods: {
    fillGap(folderId) {
      console.log(folderId);
    }
  }
};
</script>
